export const actions = {
  FETCH_FILE: 'FileDetails/FETCH_FILE',
  FETCH_FILE_SUCCESS: 'FileDetails/FETCH_FILE_SUCCESS',
  FETCH_FILE_FAILURE: 'FileDetails/FETCH_FILE_FAILURE',
}

export const REDUCER_NAME = 'FileDetails'
